import { DataBean } from "../DataBean";

export class Sprint extends DataBean {

  public async getSprintCatalogPorPropiedades(properties: any, maxRows?: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "java.util.List_getSprintCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getSprintRender(page: number, rows: number, props: any): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "com.advantage.shared.Report_getSprintRender_Number_Number_java.util.Map",
      [page, rows, props]
    );
  }

  public async deleteSprint(idsprint: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "boolean_deleteSprint_Number",
      [idsprint]
    );
  }

  public async updateSprint(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "com.advantage.processflow.bean.Sprint_updateSprint_com.advantage.processflow.bean.Sprint",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.advantage.processflow.bean.Sprint",
        },
      ]
    );
  }
}
